import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useWishlist } from "@/context/WishlistContext";
import { toast } from "sonner";

export default function WishlistButton({ productId, className = "" }) {
  const { has, toggle } = useWishlist();
  const { user } = useAuth();
  const nav = useNavigate();
  const active = has(productId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { nav("/login"); return; }
    const r = await toggle(productId);
    if (r?.ok) toast.success(active ? "Removed from wishlist" : "Saved to wishlist");
  };

  return (
    <button
      data-testid={`wish-${productId}`}
      onClick={onClick}
      aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
      className={`w-9 h-9 flex items-center justify-center bg-background border border-foreground/40 hover:border-foreground transition-colors ${className}`}
    >
      <Heart
        size={16}
        strokeWidth={1.75}
        className={active ? "text-[hsl(var(--accent))]" : ""}
        fill={active ? "hsl(var(--accent))" : "none"}
      />
    </button>
  );
}
